import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  WatchInternal,
} from "react-hook-form";
import {
  IdeogramMagicPrompt,
  IdeogramStyleType,
  IdeogramResolution,
  IdeogramAspect,
} from "../../ImageGenerator/constants";

interface Props {
  errors: FieldErrors<any>;
  register: UseFormRegister<any>;
  systemType: string;
  setSystemType: React.Dispatch<React.SetStateAction<string>>;
  watch: WatchInternal<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
  systems: any[];
}

const IdeogramConfigForm = ({
  errors,
  register,
  setSystemType,
  setValue,
  systemType,
  control,
  watch,
  systems,
}: Props) => {
  const ideogramModels = [
    {
      label: 'V3',
      value: 'ideogram-v3',
    },
    {
      label: 'V3-TURBO',
      value: 'ideogram-v3-turbo',
    },
    {
      label: 'V3-QUALITY',
      value: 'ideogram-v3-quality',
    },
  ];

  return (
    <Box>
      <Box
        mt={'16px'}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '32px',
        }}
      >
        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="ai-system-select-label">Ai System</InputLabel>
          <Select
            name="AiSystem"
            labelId="ai-system-select-label"
            id="ai-system-select"
            label="Ai System"
            value={systemType}
            onChange={e => {
              setSystemType(e.target.value);
            }}
            sx={{
              width: '100%',
            }}
          >
            {systems.map((opt, index) => (
              <MenuItem
                key={index}
                value={opt.system}
                disabled={
                  opt.models && opt.models.length > 0
                    ? opt.models.every((model: any) => model.disabledByCompany)
                    : false
                }
              >
                {opt.system === 'fal'
                  ? 'Flux'
                  : opt.system.charAt(0).toUpperCase() + opt.system.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="ideogram-model-label">Ideogram Model</InputLabel>
          <Select
            value={watch().ideogramModel}
            labelId="ideogram-model-label"
            id="ideogram-model-select"
            label="Ideogram Model"
            {...register('ideogramModel')}
            sx={{
              width: '100%',
            }}
          >
            {ideogramModels.map((model, index) => (
              <MenuItem key={index} value={model.value}>
                {model.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box
        mt={'16px'}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '32px',
        }}
      >
        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="aspect-ratio-label">Aspect Ratio</InputLabel>
          <Select
            value={watch().aspect_ratio_ideogram}
            labelId="aspect-ratio-label"
            id="aspect-ratio-select"
            label="Aspect Ratio"
            {...register('aspect_ratio_ideogram')}
            sx={{
              width: '100%',
            }}
          >
            {Object.values(IdeogramAspect).map((aspect, index) => (
              <MenuItem key={index} value={aspect}>
                {aspect}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="style-type-label">Style Type</InputLabel>
          <Select
            value={watch().style_type}
            labelId="style-type-label"
            id="style-type-select"
            label="Style Type"
            {...register('style_type')}
            sx={{
              width: '100%',
            }}
          >
            {Object.values(IdeogramStyleType).map((style, index) => (
              <MenuItem key={index} value={style}>
                {style}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box
        mt={'16px'}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '32px',
        }}
      >
        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="resolution-label">Resolution</InputLabel>
          <Select
            value={watch().resolution}
            labelId="resolution-label"
            id="resolution-select"
            label="Resolution"
            {...register('resolution')}
            sx={{
              width: '100%',
            }}
          >
            {Object.values(IdeogramResolution).map((resolution, index) => (
              <MenuItem key={index} value={resolution}>
                {resolution}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="magic-prompt-label">Magic Prompt</InputLabel>
          <Select
            value={watch().magicPrompt}
            labelId="magic-prompt-label"
            id="magic-prompt-select"
            label="Magic Prompt"
            {...register('magicPrompt')}
            sx={{
              width: '100%',
            }}
          >
            {Object.values(IdeogramMagicPrompt).map((magic, index) => (
              <MenuItem key={index} value={magic}>
                {magic}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default IdeogramConfigForm;